/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import React from "react";
import NavigationBarDesktopAuthenticated from "@/src/components/Navigation/NavigationBar/Desktop/NavigationBarDesktopAuthenticated";
import NavigationBarDesktopNonAuthenticated from "@/src/components/Navigation/NavigationBar/Desktop/NavigationBarDesktopNonAuthenticated";

export type NavigationBarDesktopProps = {
  hideActions?: boolean;
  clickableLogo?: boolean;
  mainNavigationItems: Array<
    (
      | { type: "link"; to: string }
      | {
          type: "category";
          categoryMapping: Array<{ to: string; label: string }>;
        }
    ) & { label: string; value: string | null }
  >;
};

export default function NavigationBarDesktop({ mainNavigationItems, hideActions, clickableLogo = true }: NavigationBarDesktopProps) {
  const { customer } = useCustomer();

  if (customer) {
    return <NavigationBarDesktopAuthenticated clickableLogo={clickableLogo} />;
  }

  return <NavigationBarDesktopNonAuthenticated clickableLogo={clickableLogo} mainNavigationItems={mainNavigationItems} hideActions={hideActions} />;
}
